// extracted by mini-css-extract-plugin
export default {"compareBtn":"BCompare-module_compareBtn_ec48a9f7"};